import React from "react";
import PropTypes from "prop-types";

/**
 * Product logo mark (icon only, no wordmark).
 * Fill uses `currentColor`, so the icon inherits whatever CSS
 * `color` is set on it — pass a className or style to theme it.
 */
const ProductLogoSvg = ({ size = 14, className, style, onClick, title }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 141 147"
    width={size}
    height={size}
    className={className}
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      ...style,
    }}
    onClick={onClick}
    role={title ? "img" : "presentation"}
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    <path
      fill="currentColor"
      style={{ fillRule: "nonzero" }}
      d="m167.82 109.5 16.22 24.36c3.67 5.52 3.74 12.69.17 18.28l-20.54 30.88c-8.07 12.96-15.63 14.17-28.3 14.17h-21.08c-4.14.25-3.55-2.46-2.34-4.31l55.86-83.37z"
      transform="translate(-110.058 -69.99)"
    />
    <path
      fill="currentColor"
      style={{ fillRule: "nonzero" }}
      d="m167.82 176.78 16.21-24.37c3.7-5.58 3.75-12.68.18-18.27l-20.54-30.88c-8.07-12.96-15.63-14.17-28.3-14.17h-21.08c-4.14-.25-3.55 2.46-2.34 4.31l55.86 83.37zM231.61 110.14l16.37 24.13c3.67 5.52 3.74 12.69.17 18.28l-32.57 47.95a33.48 33.48 0 0 1-28.21 15.46h-21.08c-2.21 0-3.55-2.46-2.34-4.31l67.66-101.5z"
      transform="translate(-110.058 -69.99)"
    />
    <path
      fill="currentColor"
      style={{ fillRule: "nonzero" }}
      d="m231.59 176.88 16.42-24.12c3.74-5.66 3.64-12.77.07-18.36l-32.57-47.95a33.48 33.48 0 0 0-28.21-15.46h-21.08c-2.21 0-3.55 2.46-2.34 4.31l67.72 101.59z"
      transform="translate(-110.058 -69.99)"
    />
  </svg>
);

ProductLogoSvg.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

export default ProductLogoSvg;
